import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ensureDefaultPreset } from "./defaultPreset";
import { useGeotabClient } from "@/components/GeotabClientContext";
import AddInIds from "@/constants/AddInIds";

/**
 * Creates "Fairfleet Standard" for a database without presets, once per session.
 *
 * The preset list is refreshed before the result arrives, so a stored preset is already in it.
 *
 * @param enabled - Presets and views have loaded and both are empty.
 */
export function useDefaultPreset(enabled: boolean) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ["defaultPreset", activeSessionId],
    queryFn: async () => {
      const result = await ensureDefaultPreset(geotabClient);
      if (result?.stored) {
        await queryClient.invalidateQueries({
          queryKey: ["addinData", AddInIds.presets, activeSessionId],
        });
      }
      return result;
    },
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });
}
